import { FormInstance } from 'antd/lib/form';
import { ColProps } from 'antd/lib/grid';
import { CSSProperties, MutableRefObject, ReactNode } from 'react';
import { IBtnList } from '../ButtonGroup/buttonGroup';
import { NamePath } from '../constants/interface';
import { SuperFormItemProps } from '../SuperForm/interface';
import { IBaseProps } from './subpage/baseDetailPage';
import { DetailPageType } from './context';
import { ButtonProps, ButtonType } from 'antd/lib/button';
import { StepsProps } from '../Steps/interface';

export interface DetailActionType {
  hide: () => void;
  show: () => DetailActionType | undefined;
  loading: () => DetailActionType | undefined;
  unLoading: () => DetailActionType | undefined;
  add: (initValues?: any) => DetailActionType | undefined;
  edit: (initValues: any) => DetailActionType | undefined;
  detail: (initValues: any) => DetailActionType | undefined;
  submit: () => void;
  validateFields: () => Promise<any>;
  getForms: () => FormInstance | undefined;
  update: (
    name: NamePath,
    formItem: SuperFormItemProps,
  ) => DetailActionType | undefined;
  form?: FormInstance;
}
/** 普通详情页 */
export interface DetailPageAddProps extends IBaseProps {
  /** Form表单配置 */
  formItems?: SuperFormItemProps[];
  /** 每行默认FormItem数 */
  defaultLineNumber?: number;
  /** FormItem标题配置 */
  defaultLabelCol?: ColProps;
  /** FormItem初始值 */
  initformValues?: any;
  /** FormItem值 */
  formValues?: any;
  /** 对象句柄 */
  actionRef?: MutableRefObject<DetailActionType | undefined>;
  /** 禁用所有表单 */
  disabledAll?: boolean;
  /** 自定义头部 */
  header?: ReactNode;
  /** 新增或者修改成功后停留在当前页（不返回列表） */
  isBackList?: boolean;
  /** 是否为表格的详情页 */
  isTableDetail?: boolean;
  /** 操作成功后格式化返回数据 */
  formatData?: (values: any) => any;
  /** 操作接口 */
  fetchApi?: (params?: any) => Promise<any>;
  /** 详情 */
  detailApi?: (params?: any) => Promise<any>;
  /** 调用接口之前回调 */
  beforeSubmit?: (values: any) => any;
  /**
   * 调用草稿箱之前回调
   * @param isCover 是否为覆盖新增
   * @param values 表单内容
   */
  beforeDraftsSubmit?: (isCover: boolean, values: any) => any;
  /** 调用接口成功 */
  onSuccess?: (res: any) => void;
  /** 调用接口失败 */
  onFail?: (err: any) => void;
  /** 点击确定按钮回调（如果传入此方法则提交步骤由外部实现） */
  onSubmit?: (values: any) => void;
  /** 新增/修改成功完成时回调 */
  onSuccessed?: (data: any) => void;
}
/** 规则详情页 */
export interface DetailPageRuleProps extends IBaseProps {
  /** 对象句柄 */
  actionRef?: MutableRefObject<DetailActionType | undefined>;
}

export type DetailButtonType = IBtnList[] | { label: ReactNode; key: string; buttonList: IBtnList[]; icon?: ReactNode; };

export enum sizeenum {
  full = '100%',
  large = '90%',
  middle = '70%',
  small = '50%',
}

export type textAlignType = 'left' | 'right' | 'center';
export type sizeType = 'full' | 'large' | 'middle' | 'small' | false;

export interface IBaseStrategyPageProps {
  /** 返回文字 */
  backText?: ReactNode;
  /** 详情页标题 */
  title?: ReactNode;
  /** 详情头部右侧操作按钮 */
  footer?: ReactNode[] | false;
  /** 确定按钮type */
  okType?: ButtonType;
  /** 取消按钮type */
  cancelType?: ButtonType;
  /** 确定按钮文字 */
  okText?: ReactNode;
  /** 新增按钮文字 */
  addButtonText?: ReactNode;
  /** 编辑按钮文字 */
  editButtonText?: ReactNode;
  /** 取消编辑按钮文字 */
  cancelEditButtonText?: ReactNode;
  /** 取消编辑按钮文字 */
  showCancelEditButton?: boolean;
  /** 确定按钮是否处于loading状态 */
  confirmLoading?: boolean;
  /** 确定按钮其他状态 */
  okButtonProps?: ButtonProps;
  /** 取消按钮文字 */
  cancelText?: ReactNode;
  /** 页面对齐方式 */
  textAlign?: textAlignType;
  /** 页面宽度 优先级较高 */
  width?: string | number;
  /** 页面宽度 */
  size?: sizeType;
  /** 页面挂载节点或者id */
  getContainer?: HTMLElement | string;
  /** 关联列表的id */
  tableId?: HTMLElement | string;
  /** 编辑按钮文字 */
  detailText?: ReactNode;
  /** 编辑按钮其他状态 */
  detailButtonProps?: ButtonProps;
  /** 编辑按钮type */
  detailType?: ButtonType;
  /** 是否隐藏确定或者编辑按钮 */
  hideOkButton?: boolean;
  /** 编辑按钮权限 */
  editButtonAuthorityCode?: string;
  /** 编辑按钮权限 */
  isEditAuth?: boolean;
  /** 内容样式 */
  contentStyle?: CSSProperties;
  /** 测试ID */
  testId?: string;
  /** 关闭时还原清空表单项 */
  destroyOnClose?: boolean;
  /** 最外层容器类名 */
  wrapperClassName?: string;
  /** 头部容器类名 */
  headClassName?: string;
  /** 内容容器类名 */
  bodyClassName?: string;
  /** 详情内容是否要占满整个页面 */
  isFullPage?: boolean;
  /** 打开详情页时需要隐藏的className */
  otherHideClassName?: string;
  /** 最小宽度 */
  minWidth?: string | number;
  /** 是否隐藏返回按钮 */
  hideBack?: boolean;
  /** 头部进度条 */
  headerProps?: StepsProps;
  /** 自定义详情页底部 */
  footerNode?: ReactNode;
  /** 底部类名 */
  footerClassName?: string;
  /** 底部样式 */
  footerStyle?: CSSProperties;
  /** 其他按钮 */
  otherButtons?: DetailButtonType[];
  /** 子节点 */
  children?: ReactNode;
  /** 详情页显示隐藏切换回调 */
  onVisibleChange?: (visible: boolean) => void;
  /** 点击返回或者关闭回调 */
  onBack?: () => void;
  /** 点击编辑按钮回调 */
  onDetail?: () => void;
  /** 点击其他按钮 */
  onClickOtherButton?: (key: string) => void;
  /** 点击取消编辑回调 */
  onCancelEdit?: () => void;
}

/** 规则页面公共props */
export interface SubpageBaseProps {
  /** 禁用所有表单 */
  disabled?: boolean;
}
/** 规则页面props */
export interface StrategyPageProps extends SubpageBaseProps, IBaseStrategyPageProps {
  /** 对象句柄 */
  actionRef?: MutableRefObject<StrategyActionType | undefined>;
  /** 规则配置 */
  ruleFormItems?: SuperFormItemProps[];
  /** 动作配置 */
  actionFormItems?: SuperFormItemProps[];
  /** 可选条件配置 */
  optionalFormItems?: IOptionalFormItems[];
  /** 可选条件值接收字段 值为false时不接收可选条件的值 */
  optionalFiledName?: string | false;
  /** 操作成功后格式化返回数据 */
  formatData?: (values: any) => any;
  /** 操作接口 */
  fetchApi?: (params?: any) => Promise<any>;
  /** 调用接口之前回调 */
  beforeSubmit?: (values: any) => any;
  /** 调用接口成功 */
  onSuccess?: (res: any) => void;
  /** 调用接口失败 */
  onFail?: (err: any) => void;
  /** 点击确定按钮回调（如果传入此方法则提交步骤由外部实现） */
  onSubmit?: (values: any) => void;
};

/** 规则页面左侧props */
export interface StrategyPageLeftProps extends SubpageBaseProps {
  /** 表单对象 */
  ruleFormRef: MutableRefObject<FormInstance<any> | undefined>;
}
/** 规则页面左侧props */
export interface StrategyPageContentProps extends SubpageBaseProps {
  /** 表单对象 */
  contentFormRef: MutableRefObject<FormInstance<any> | undefined>;
}
/** 规则页面左侧props */
export interface StrategyPageRightProps extends SubpageBaseProps {
  /** 表单对象 */
  actionFormRef: MutableRefObject<FormInstance<any> | undefined>;
}

export interface IStrategyPageContext {
  /** 显示隐藏 */
  visible?: boolean;
  /** 页面类型 */
  pageType?: DetailPageType;
  /** 规则配置 */
  ruleFormItems: SuperFormItemProps[];
  /** 动作配置 */
  actionFormItems: SuperFormItemProps[];
  /** 可选条件配置 */
  optionalFormItems: IOptionalFormItems[];
  /** 选择后的内容区域 */
  contentFormItems: SuperFormItemProps[];
  /** 可选配置表单对象 */
  optionalFormRef?: MutableRefObject<FormInstance<any> | undefined>;
};

export interface IStrategyPageAction {
  type: StrategyPageType;
  payload: IStrategyPagePayload;
}
/** Action方法名 */
export type StrategyPageType = 'init' | 'change' | 'changeFormItem' | 'initContentFormItems' | 'empty';
/** Action入参 */
export interface IStrategyPagePayload {
  /** 显示隐藏 */
  visible?: boolean;
  /** 页面类型 */
  pageType?: DetailPageType;
  /** 可选条件值 */
  optionalValues?: any;
  /** 初始值 */
  initValues?: StrategyInitValues,
  /** 规则配置 */
  ruleFormItems?: SuperFormItemProps[];
  /** 可选条件配置 */
  optionalFormItems?: IOptionalFormItems[];
  /** 修改的表单配置组 */
  groupOptions?: IGroupOption;
  /** 动作配置 */
  actionFormItems?: SuperFormItemProps[];
  /** 可选配置表单对象 */
  optionalFormRef?: MutableRefObject<FormInstance<any> | undefined>;
};
/** 可选条件配置接口 */
export interface IOptionalFormItems {
  label: ReactNode;
  value: string;
  children: SuperFormItemProps[];
};
/**  */
export interface IGroupOption {
  name: string;
  value: any[];
}

export interface StrategyAction {
  /** 关闭页面 */
  hide: () => void;
  /** 显示页面 */
  show: () => StrategyActionType;
  /** 设置页面为加载中状态 */
  loading: () => StrategyActionType;
  /** 取消页面加载中状态 */
  unLoading: () => StrategyActionType;
  /**
   * 新增
   * @param initValues 表单默认值
   * @returns 
   */
  add: (initValues?: StrategyInitValues) => StrategyActionType;
  /**
   * 编辑
   * @param initValues 表单默认值
   * @returns 
   */
  edit: (initValues: StrategyInitValues) => StrategyActionType;
  /**
   * 查看
   * @param initValues 表单默认值
   * @returns 
   */
  detail: (initValues: StrategyInitValues) => StrategyActionType;
  /** 提交 */
  submit: () => void;
  /** 清空选中条件 */
  emptySelected: () => void;
  /**
   * 批量赋值
   * @param values
   * @returns 
   */
  setValues: (values: StrategyInitValues) => void;
  /**
   * 单个字段赋值
   * @param formType 表单类型
   * @param filed 字段名称
   * @param value 字段值
   * @returns 
   */
  setValue: (formType: StrategyFormType, filed: any, value: any) => void;
}

/** 表单类型 */
export type StrategyFormType = 'rule' | 'content' | 'action';

export type StrategyActionType = StrategyAction | undefined;
/** 策略默认值 */
export interface StrategyInitValues {
  /** 左侧规则表单默认值 */
  rule?: any;
  /** 中间内容区域表单默认值 */
  content?: any;
  /** 右侧动作默认值默认值 */
  action?: any;
}
